<template>
  <w-settings-content-template>
    <div slot="content" style="width: 50%">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box title-h3">Compact</div>
        <div class="vertical-center-box">
          <el-button class="mr-r4" type="primary" @click="onSaveButtonClick('compact')" :disabled="!compactModifiedFlag">저장</el-button>
          <el-button @click="onClickCancelButton('compact')" :disabled="!compactModifiedFlag">취소</el-button>
        </div>
      </el-row>
      <el-row class="mr-b30">
        <div class="list form-list">
          <el-form label-width="200px" label-position="left" :model="compactFormInfo">
            <el-form-item label="CPU" prop="core">
              <el-input type="number" v-model="compactFormInfo.core.value" style="width: calc(100% - 75px)"></el-input>
              <span class="mr-4">개</span>
            </el-form-item>
            <el-form-item label="메모리" prop="memory">
              <el-input type="number" v-model="compactFormInfo.memory.value" style="width: calc(100% - 75px)"></el-input>
              <el-select v-model="compactFormInfo.memory.unit" style="width: 62px">
                <el-option v-for="item in memoryUnitList" :key="item.label" :value="item.label" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="디스크" prop="disk">
              <el-input type="number" v-model="compactFormInfo.disk.value" style="width: calc(100% - 75px)"></el-input>
              <el-select v-model="compactFormInfo.disk.unit" style="width: 62px">
                <el-option v-for="item in diskUnitList" :key="item.label" :value="item.label" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box title-h3">Standard</div>
        <div class="vertical-center-box">
          <el-button class="mr-r4" type="primary" @click="onSaveButtonClick('standard')" :disabled="!standardModifiedFlag">저장</el-button>
          <el-button @click="onClickCancelButton('standard')" :disabled="!standardModifiedFlag">취소</el-button>
        </div>
      </el-row>
      <el-row class="mr-b30">
        <div class="list form-list">
          <el-form label-width="200px" label-position="left" :model="standardFormInfo">
            <el-form-item label="CPU" prop="core">
              <el-input type="number" v-model="standardFormInfo.core.value" style="width: calc(100% - 75px)"></el-input>
              <span class="mr-4">개</span>
            </el-form-item>
            <el-form-item label="메모리" prop="memory">
              <el-input type="number" v-model="standardFormInfo.memory.value" style="width: calc(100% - 75px)"></el-input>
              <el-select v-model="standardFormInfo.memory.unit" style="width: 62px">
                <el-option v-for="item in memoryUnitList" :key="item.label" :value="item.label" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="디스크" prop="disk">
              <el-input type="number" v-model="standardFormInfo.disk.value" style="width: calc(100% - 75px)"></el-input>
              <el-select v-model="standardFormInfo.disk.unit" style="width: 62px">
                <el-option v-for="item in diskUnitList" :key="item.label" :value="item.label" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box title-h3">Extend</div>
        <div class="vertical-center-box">
          <el-button class="mr-r4" type="primary" @click="onSaveButtonClick('extend')" :disabled="!extendModifiedFlag">저장</el-button>
          <el-button @click="onClickCancelButton('extend')" :disabled="!extendModifiedFlag">취소</el-button>
        </div>
      </el-row>
      <el-row>
        <div class="list form-list">
          <el-form label-width="200px" label-position="left" :model="extendFormInfo">
            <el-form-item label="CPU" prop="core">
              <el-input type="number" v-model="extendFormInfo.core.value" style="width: calc(100% - 75px)"></el-input>
              <span class="mr-4">개</span>
            </el-form-item>
            <el-form-item label="메모리" prop="memory">
              <el-input type="number" v-model="extendFormInfo.memory.value" style="width: calc(100% - 75px)"></el-input>
              <el-select v-model="extendFormInfo.memory.unit" style="width: 62px">
                <el-option v-for="item in memoryUnitList" :key="item.label" :value="item.label" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="디스크" prop="disk">
              <el-input type="number" v-model="extendFormInfo.disk.value" style="width: calc(100% - 75px)"></el-input>
              <el-select v-model="extendFormInfo.disk.unit" style="width: 62px">
                <el-option v-for="item in diskUnitList" :key="item.label" :value="item.label" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
    </div>
  </w-settings-content-template>
</template>

<script>
import { camelCase, cloneDeep, isEqual, mapKeys, isNil } from 'lodash';
import basicinfoSetAPI from '@/api/model/basicinfo-set';
import msgUtil from '@/utils/message';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';

export default {
  name: 'WServerHardwareSetting',
  components: {
    WSettingsContentTemplate,
  },
  data() {
    return {
      resultData: [],
      compactFormInfo: {
        core: {},
        memory: {},
        disk: {},
      },
      standardFormInfo: {
        core: {},
        memory: {},
        disk: {},
      },
      extendFormInfo: {
        core: {},
        memory: {},
        disk: {},
      },
      originCompactFormInfo: {},
      originStandardFormInfo: {},
      originExtendFormInfo: {},
      compactModifiedFlag: false,
      standardModifiedFlag: false,
      extendModifiedFlag: false,
      memoryUnitList: [
        { label: 'MB' },
        { label: 'GB' },
      ],
      diskUnitList: [
        { label: 'MB' },
        { label: 'GB' },
        { label: 'TB' },
      ],
    };
  },
  watch: {
    compactFormInfo: {
      deep: true,
      handler() {
        this.changeFormModifiedFlag('compact');
      },
    },
    standardFormInfo: {
      deep: true,
      handler() {
        this.changeFormModifiedFlag('standard');
      },
    },
    extendFormInfo: {
      deep: true,
      handler() {
        this.changeFormModifiedFlag('extend');
      },
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData(formName) {
      basicinfoSetAPI.getList('VMHWSPEC').then((response) => {
        const result = response.data;
        if (result.success) {
          this.resultData = result.data;
          this.$nextTick(() => {
            if (isNil(formName)) {
              this.loadCompactData();
              this.loadStandardData();
              this.loadExtendData();
            } else {
              this[camelCase(`load_${formName}Data`)]();
            }
          });
        }
      });
    },
    loadCompactData() {
      const compactFormInfo = {};
      this.resultData.forEach((row) => {
        if (row.basicinfoSubid.indexOf('COMPACT') >= 0) {
          const dataSet = {
            value: row.basicinfoSubvalueInteger.toString(),
            unit: row.basicinfoSubunit,
          };
          compactFormInfo[camelCase(this.getResourceName(row.basicinfoSubid))] = dataSet;
        }
      });
      this.compactFormInfo = cloneDeep(compactFormInfo);
      this.originCompactFormInfo = cloneDeep(compactFormInfo);
    },
    loadStandardData() {
      const standardFormInfo = {};
      this.resultData.forEach((row) => {
        if (row.basicinfoSubid.indexOf('STANDARD') >= 0) {
          const dataSet = {
            value: row.basicinfoSubvalueInteger.toString(),
            unit: row.basicinfoSubunit,
          };
          standardFormInfo[camelCase(this.getResourceName(row.basicinfoSubid))] = dataSet;
        }
      });
      this.standardFormInfo = cloneDeep(standardFormInfo);
      this.originStandardFormInfo = cloneDeep(standardFormInfo);
    },
    loadExtendData() {
      const extendFormInfo = {};
      this.resultData.forEach((row) => {
        if (row.basicinfoSubid.indexOf('EXTEND') >= 0) {
          const dataSet = {
            value: row.basicinfoSubvalueInteger.toString(),
            unit: row.basicinfoSubunit,
          };
          extendFormInfo[camelCase(this.getResourceName(row.basicinfoSubid))] = dataSet;
        }
      });
      this.extendFormInfo = cloneDeep(extendFormInfo);
      this.originExtendFormInfo = cloneDeep(extendFormInfo);
    },
    getResourceName(string) {
      return string.split('_')[1];
    },
    changeFormModifiedFlag(formName) {
      this[`${formName}ModifiedFlag`] = !isEqual(this[`${formName}FormInfo`], this[camelCase(`origin_${formName}FormInfo`)]);
    },
    onSaveButtonClick(formName) {
      const target = '정보';
      const action = msgUtil.action.SAVE;
      const basicinfoSetList = [];
      mapKeys(this[`${formName}FormInfo`], (value, key) => {
        if (!isEqual(value, this[camelCase(`origin_${formName}FormInfo`)][key])) {
          // debugger;
          const basicinfoId = 'VMHWSPEC';
          const basicinfoSubid = `${formName.toUpperCase()}_${key.toUpperCase()}`;
          const basicinfoSubvalueInteger = value.value;
          const basicinfoSubunit = value.unit;
          basicinfoSetList.push({
            basicinfoId,
            basicinfoSubid,
            basicinfoSubvalueInteger,
            basicinfoSubunit,
          });
        }
      });
      basicinfoSetAPI.updateList(basicinfoSetList).then((response) => {
        const result = response.data;
        if (result.success) {
          this.loadData(formName);
          this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    onClickCancelButton(formName) {
      this[camelCase(`load_${formName}Data`)]();
    },
    onChangeTargetValue(formName) {
      this.changeFormModifiedFlag(formName);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/VirtualService/ServerHardwareSetting/index.vue